import { render, staticRenderFns } from "./discount_codes.vue?vue&type=template&id=58791f7a&"
import script from "./discount_codes.vue?vue&type=script&lang=js&"
export * from "./discount_codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports